import React from 'react';

import { StyledFormControl } from './FormControl.styles';

import { FormControlProps } from './FormControl.types';

/**
 * Wrapper for inputs, select...
 */
const FormControl = ({
  children,
  isRequired = false,
  formControlName = '',
  formControlLabel = '',
  additionalContent = '',
  componentClassname = 'form-control',
  customClassnames = '',
  customStyle = '',
  ...props
}: FormControlProps) => {
  return (
    <StyledFormControl
      className={`${componentClassname} ${
        isRequired ? `${componentClassname}--is-required` : ''
      } ${customClassnames}`}
      customStyle={customStyle}
      {...props}
    >
      <div className="form-control__information-line">
        {/* eslint-disable-next-line jsx-a11y/label-has-for */}
        <label className="form-control__label" htmlFor={formControlName}>
          {formControlLabel}
        </label>
        {additionalContent}
      </div>
      {children}
    </StyledFormControl>
  );
};
FormControl.displayName = 'FormControl';

export default FormControl;
